import InvoiceController from 'src/features/billing/invoices/InvoiceController';
import { PriceSummaryModal } from 'src/features/pricing/PriceSummaryModal/PriceSummaryModal';
import { DownloadDetailsModal } from 'src/features/trip/management/download/DownloadDetailsModal';
import { DownloadModal } from 'src/features/trip/management/download/DownloadModal';
import { UploadDetailsModal } from 'src/features/trip/management/UploadDetailsModal/UploadDetailsModal';
import { UploadModal } from 'src/features/trip/management/UploadModal';
import TripStatusUpdatesModal from 'src/features/trip/status-update/TripStatusUpdatesModal';

import TripSubscriptionModal from '../trip-subscriptions/trip-subscription-form/TripSubscriptionModal';
import { BulkCancelTripModal } from './cancel/BulkCancelTripModal/BulkCancelTripModal';
import CancelSuggestionsModal from './cancel/CancelSuggestionsModal/CancelSuggestionsModal';
import CancelTripModal from './cancel/CancelTripModal/CancelTripModal';
import { CSVImportStatusContent } from './CSVImportStatusContent';
import { TripDeleteModal } from './TripDeleteModal';
import { TripManagementDataGrid } from './TripManagementDataGrid/TripManagementDataGrid';
import TripTagsModal from './TripTagModal';

export function TripManagementRouteContent() {
  return (
    <>
      <CSVImportStatusContent />
      <TripManagementDataGrid />
      <DownloadModal />
      <DownloadDetailsModal />
      <UploadModal />
      <UploadDetailsModal />
      <TripTagsModal />
      <InvoiceController />
      <BulkCancelTripModal />
      <CancelTripModal />
      <CancelSuggestionsModal />
      <TripStatusUpdatesModal />
      <PriceSummaryModal />
      <TripSubscriptionModal />
      <TripDeleteModal />
    </>
  );
}
